const EXTRA_VAR = '--vec-fit-extra';
const SCALE_VAR = '--eq-scale';
const CONTENT_SELECTOR = '[data-vec-option-content]';

const fitContent = (root, { minScale = 0.8 } = {}) => {
    let frame = null;
    let disposed = false;

    const refresh = () => {
        root.removeAttribute('data-scrolls');
        root.style.removeProperty(EXTRA_VAR);
        const items = Array.from(root.querySelectorAll(CONTENT_SELECTOR));
        items.forEach((el) => el.style.setProperty(SCALE_VAR, 1));

        const measured = items.map((el) => ({ el, natural: el.scrollWidth, available: el.clientWidth }));
        const ratios = measured.filter((m) => m.available > 0 && m.natural > 0).map((m) => m.available / m.natural);
        const scale = Math.max(minScale, Math.min(1, ...ratios));

        measured.forEach(({ el }) => el.style.setProperty(SCALE_VAR, scale));
        const extra = Math.max(0, ...measured.map(({ natural, available }) => natural * scale - available));
        const scrolls = extra > 1;
        root.toggleAttribute('data-scrolls', scrolls);
        if (scrolls) root.style.setProperty(EXTRA_VAR, `${Math.ceil(extra)}px`);
        else root.style.removeProperty(EXTRA_VAR);
    };

    const schedule = () => {
        if (frame !== null || disposed) return;
        frame = requestAnimationFrame(() => {
            frame = null;
            refresh();
        });
    };

    const resizeObserver = new ResizeObserver(schedule);
    resizeObserver.observe(root);
    const mutationObserver = new MutationObserver(schedule);
    mutationObserver.observe(root, { childList: true, subtree: true, characterData: true });
    document.fonts?.addEventListener('loadingdone', schedule);
    document.fonts?.ready.then(schedule);
    schedule();

    return () => {
        disposed = true;
        resizeObserver.disconnect();
        mutationObserver.disconnect();
        document.fonts?.removeEventListener('loadingdone', schedule);
        if (frame !== null) cancelAnimationFrame(frame);
        root.removeAttribute('data-scrolls');
        root.style.removeProperty(EXTRA_VAR);
        root.querySelectorAll(CONTENT_SELECTOR).forEach((el) => el.style.removeProperty(SCALE_VAR));
    };
};

export default fitContent;
